import {SaveSaleVehicleLeasingBody} from '@dms/api/vehicle';

import {LeasingCellCoordinates} from '../../types/LeasingCellCoordinates';

type ActiveLeasingCoordinates = Pick<
  SaveSaleVehicleLeasingBody,
  'activeTerm' | 'activeAnnualMileage'
>;

export function isActiveLeasingCell(
  vehicleLeasingBody: ActiveLeasingCoordinates,
  coordinates: LeasingCellCoordinates
) {
  return (
    vehicleLeasingBody.activeTerm === coordinates.term &&
    vehicleLeasingBody.activeAnnualMileage === coordinates.annualMileage
  );
}
